import GlobalStyle from './shared/globalStyles';
import Page from './components/Page';
require('intersection-observer');


function App() {
  return (
    <>
      <GlobalStyle />
      <Page />
    </>    
  );
}

export default App;
